import { QueryKeys } from "@/constants/Query";
import { useApiMutation } from "@/hooks/useApiMutation";
import axiosInstance from "@/lib/axios";
import { useQueryClient } from "@tanstack/react-query";
import type * as fhirTypes from "fhir/r4";

interface CreateFileParams {
  patientId: string;
  categoryId: string;
  eocId?: string;
  file: File;
}

interface CreateFileResponse {
  documentReference: fhirTypes.DocumentReference;
}

export const useCreateFile = (patientId: string) => {
  const queryClient = useQueryClient();

  return useApiMutation<CreateFileResponse, CreateFileParams>({
    mutationOptions: {
      mutationKey: QueryKeys.Patient.MedicalRecords.Files.CREATE(patientId),
      mutationFn: (params) => {
        const formData = new FormData();
        formData.append("file", params.file);
        formData.append("categoryId", params.categoryId);
        formData.append("patientId", params.patientId);

        if (params.eocId) formData.append("eocId", params.eocId);

        return axiosInstance.post("/charting/files/", formData, {
          headers: {
            "Content-Type": "multipart/form-data",
          },
        });
      },
      onSuccess: () => {
        queryClient.invalidateQueries({
          queryKey: QueryKeys.Patient.MedicalRecords.Files.DEFAULT(patientId),
        });
      },
    },
  });
};
